import * as React from "react"
import {
  Edit,
} from "react-admin"
import ContactForm from "./ContactForm"

const ContactTitle = () => {
  return <span>{'聯絡表單'}</span>
}

const ContactEdit = () => (
  <Edit 
    title={<ContactTitle/>} 
    redirect={false}
    mutationMode="optimistic"
  >
    <ContactForm 
      formType="edit" 
    />
  </Edit>
)

export default ContactEdit